"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _StandardIconWrapper = _interopRequireDefault(require("./StandardIconWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var ShareArrowIcon =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(ShareArrowIcon, _React$PureComponent);

  function ShareArrowIcon() {
    _classCallCheck(this, ShareArrowIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(ShareArrowIcon).apply(this, arguments));
  }

  _createClass(ShareArrowIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          color = _this$props.color,
          className = _this$props.className,
          props = _objectWithoutProperties(_this$props, ["color", "className"]);
      /* eslint-disable max-len */


      return _react.default.createElement(_StandardIconWrapper.default, _extends({
        className: (0, _classnames.default)(className, 'share-arrow-icon')
      }, props), _react.default.createElement("path", {
        fill: color,
        d: "M3,0.0001 C3.553,0.0001 4,0.448096267 4,1.0001 L4,1.0001 L3.99328243,1.11685065 C3.93560204,1.61466308 3.5135,2.00008333 3,2.00008333 L3,2.00008333 L2.25,2.00008333 C2.112,2.00008333 2,2.1120824 2,2.25008125 L2,2.25008125 L2,9.75001875 C2,9.8880176 2.112,10.0000167 2.25,10.0000167 L2.25,10.0000167 L9.75,10.0000167 C9.888,10.0000167 10,9.8880176 10,9.75001875 L10,9.75001875 L10,9.000025 C10,8.44702961 10.447,8.00003333 11,8.00003333 L11,8.00003333 L11.1167533,8.00675084 C11.6145765,8.06443076 12,8.48652928 12,9.000025 L12,9.000025 L12,10.7500104 C12,11.4400047 11.44,12 10.75,12 L10.75,12 L1.25,12 C0.56,12 0,11.4400047 0,10.7500104 L0,10.7500104 L0,1.25008958 C0,0.560095333 0.56,0.0001 1.25,0.0001 L1.25,0.0001 Z M10.7496,0 C10.7936,0 10.8306,0.020999825 10.8726,0.0249997917 C11.1696,-0.0139998833 11.4786,0.0649994583 11.7066,0.292997558 C11.9356,0.52199565 12.0136,0.829993083 11.9756,1.12699061 C11.9796,1.16899026 11.9996,1.20698994 11.9996,1.24998958 L11.9996,1.24998958 L11.9996,4.99995833 C11.9996,5.55195373 11.5526,5.99995 10.9996,5.99995 C10.4476,5.99995 9.9996,5.55195373 9.9996,4.99995833 L9.9996,4.99995833 L9.9996,3.41497154 L5.7066,7.70693578 C5.5116,7.90193415 5.2556,7.99993333 4.9996,7.99993333 C4.7446,7.99993333 4.4886,7.90193415 4.2926,7.70693578 C3.9026,7.31593903 3.9026,6.6839443 4.2926,6.29294756 L4.2926,6.29294756 L8.5856,1.99998333 L6.9996,1.99998333 C6.4486,1.99998333 5.9996,1.55198707 5.9996,1 L5.9996,1 L6.00634599,0.883246032 C6.06426327,0.385420258 6.48795714,0 6.9996,0 L6.9996,0 Z"
      }));
      /* eslint-enable max-len */
    }
  }]);

  return ShareArrowIcon;
}(_react.default.PureComponent);

exports.default = ShareArrowIcon;
ShareArrowIcon.defaultProps = {
  color: 'inherit'
};
ShareArrowIcon.propTypes = {
  className: _propTypes.default.string,
  color: _propTypes.default.string
};